import styled from 'styled-components';

export const PaddingForCard = styled.div`
  padding: 48px max(8px, min(3vw, 42px));
`;